export const COLOR_OUTERSPACE = 'outerspace';
export const COLOR_SIDECAR_DARK = 'sidecarDark';
export const COLOR_SIDECAR = 'sidecar';
export const COLOR_SIDECAR_LIGHTER = 'sidecarLighter';
export const COLOR_BLACK = 'black';
export const COLOR_WHITE = 'white';
export const COLOR_SLATE = 'slate';
export const COLOR_LIGHT_SLATE = 'lightSlate';
export const COLOR_LIME = 'lime';
export const COLOR_LIGHT_LIME = 'lightLime';
export const COLOR_ERROR = 'errorColor';
export const COLOR_NEUTRAL_LIGHT = 'neutralLight';
export const COLOR_NEUTRAL_LIGHTER = 'neutralLighter';
export const COLOR_NEUTRAL_LIGHTEST = 'neutralLightest';
export const COLOR_NEUTRAL_DARK = 'neutralDark';
export const COLOR_NEUTRAL_DARKER = 'neutralDarker';
export const COLOR_NEUTRAL_DARKEST = 'neutralDarkest';
export const COLOR_EARLS_GREEN_LIGHT = 'earlsGreenLight';
export const COLOR_EARLS_GREEN_LIGHTER = 'earlsGreenLighter';
export const COLOR_EARLS_GREEN_LIGHTEST = 'earlsGreenLightest';
export const COLOR_EARLS_GREEN = 'earlsGreen';
export const COLOR_EARLS_GREEN_DARK = 'earlsGreenDark';
export const COLOR_EARLS_GREEN_DARKER = 'earlsGreenDarker';
export const COLOR_EARLS_GREEN_DARKEST = 'earlsGreenDarkest';

export type ColorOuterspace = typeof COLOR_OUTERSPACE;
export type ColorSidecarDark = typeof COLOR_SIDECAR_DARK;
export type ColorSidecar = typeof COLOR_SIDECAR;
export type ColorSidecarLighter = typeof COLOR_SIDECAR_LIGHTER;
export type ColorBlack = typeof COLOR_BLACK;
export type ColorWhite = typeof COLOR_WHITE;
export type ColorSlate = typeof COLOR_SLATE;
export type ColorLightSlate = typeof COLOR_LIGHT_SLATE;
export type ColorLime = typeof COLOR_LIME;
export type ColorLightLime = typeof COLOR_LIGHT_LIME;
export type ColorError = typeof COLOR_ERROR;
export type ColorNeutralLight = typeof COLOR_NEUTRAL_LIGHT;
export type ColorNeutralLighter = typeof COLOR_NEUTRAL_LIGHTER;
export type ColorNeutralLightest = typeof COLOR_NEUTRAL_LIGHTEST;
export type ColorNeutralDark = typeof COLOR_NEUTRAL_DARK;
export type ColorNeutralDarker = typeof COLOR_NEUTRAL_DARKER;
export type ColorNeutralDarkest = typeof COLOR_NEUTRAL_DARKEST;
export type ColorEarlsGreen = typeof COLOR_EARLS_GREEN;
export type ColorEarlsGreenLight = typeof COLOR_EARLS_GREEN_LIGHT;
export type ColorEarlsGreenLighter = typeof COLOR_EARLS_GREEN_LIGHTER;
export type ColorEarlsGreenLightest = typeof COLOR_EARLS_GREEN_LIGHTEST;
export type ColorEarlsGreenDark = typeof COLOR_EARLS_GREEN_DARK;
export type ColorEarlsGreenDarker = typeof COLOR_EARLS_GREEN_DARKER;
export type ColorEarlsGreenDarkest = typeof COLOR_EARLS_GREEN_DARKEST;

export type Colors =
  | ColorBlack
  | ColorWhite
  | ColorOuterspace
  | ColorSidecarDark
  | ColorSidecar
  | ColorSidecarLighter
  | ColorSlate
  | ColorLightSlate
  | ColorLime
  | ColorLightLime
  | ColorNeutralLight
  | ColorNeutralLighter
  | ColorNeutralLightest
  | ColorNeutralDark
  | ColorNeutralDarker
  | ColorNeutralDarkest
  | ColorEarlsGreen
  | ColorEarlsGreenLight
  | ColorEarlsGreenLighter
  | ColorEarlsGreenLightest
  | ColorEarlsGreenDark
  | ColorEarlsGreenDarker
  | ColorError;

export type ButtonColors =
  | ColorOuterspace
  | ColorLime
  | ColorSidecarDark
  | ColorSidecar
  | ColorEarlsGreenDark
  | ColorWhite;

export type ContentBlockBackgroundColors = ColorSidecarLighter | ColorWhite;
